export default __webpack_public_path__ + "static/media/Serenity.57903a2c.jpg";